import { ApiUtils } from '@/utils/ApiUtils'
import { resetState } from '@/utils/Storage'

const initialState = ()=> {
  return  {
    offers: [],
    nextPage: null,
  }
}

export default {
  namespaced: true,
  state: {
    offers: [],
    nextPage: null,
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    setOffers(state, payload) {
      if (payload.isNextPage)
        state.offers = [...state.offers, ...payload.data]
      else
        state.offers = payload.data
    },
    setNextPage(state, payload) {
      state.nextPage = payload
    },
    addNewOffer(state, payload) {
      state.offers.unshift(payload)
    },
    publishOffer(state, payload) {
      const i = state.offers.findIndex(el => el.id === payload.id)
      if (i !== -1) 
        state.offers[i].active = true
    },
    deleteOffer(state, payload) {
      const i = state.offers.findIndex(el => el.id === payload.id)
      if (i !== -1) 
        state.offers.splice(i, 1)
    },
    saveEditedOffer(state, payload) {
      const i = state.offers.findIndex(el => el.id === payload.id)
      if (i !== -1) {
        const o = state.offers[i]
        o.title = payload.offer.title
        o.description = payload.offer.description
        o.expires = payload.offer.expires_at
      }
    }
  },
  actions: {
    async getOffers(ctx, payload) { //query //nextPage
      const { id } = ctx.rootState.currentProvider
      let url = ''
      let isNextPage = false
      if (payload.nextPage && ctx.state.nextPage) {
        isNextPage = true
        url = ctx.state.nextPage.split('/v1/')[1]
      } else {
        url = payload.query ? `provider/${id}/special_sales?per_page=10&${payload.query}` : `provider/${id}/special_sales?per_page=10`
      }
      const sales = await ApiUtils.makeGet(url)
      const json = await sales.json()
      let data
      if (sales.ok) {
        const p = json.result.special_sales
        data = {
          ok: true,
          data: mapOffers(p.data),
          current_page: p.current_page,
          last_page: p.last_page,
          next_page_url: p.next_page_url,
          total_items: p.total
        }
        ctx.commit('setOffers', {data: data.data, isNextPage})
        ctx.commit('setNextPage', data.next_page_url)
        return data
      }
      return {ok: false, data: null}
    },
    async addNewOffer(ctx, payload) {
      const { id } = ctx.rootState.currentProvider
      const url = `provider/${id}/special_sale`
      try {
        const response = await ApiUtils.makePost(url, payload)
        const json = await response.json()
        if (response.ok) {
          const single = mapSingleOffer(json.result.special_sale)
          ctx.commit('showSnackBar', 'Oferta Creada', {root: true})
          ctx.commit('addNewOffer', single)
          return { ok: true, data: single }
        }
        return { ok: false, data: null }
      } catch (error) {

        return { ok: false, data: null }
      } 
    }, 
    async publishOffer(ctx, payload) {
      const { id } = ctx.rootState.currentProvider
      const url = `provider/${id}/special_sale/${payload.id}/publish`
      try {
        const response = await ApiUtils.makePost(url)
        if (response.ok) {
          ctx.commit('publishOffer', payload)
          ctx.commit('showSnackBar', 'Oferta Publicada', {root: true})
        }
      } catch (error) {

      }
    },
    async deleteOffer(ctx, payload) {
      const { id } = ctx.rootState.currentProvider
      const url = `provider/${id}/special_sale`
      try {
        const response = await ApiUtils.makeDelete(url, payload.id)
        if (response.ok) {
          // ctx.commit('deleteOffer', payload)
          ctx.commit('showSnackBar', 'Oferta Eliminada', {root: true})
        }
        return response.ok
      } catch (error) {

        return false
      }
    },
    async editOffer(ctx, payload) {
      const { id } = ctx.rootState.currentProvider
      const url = `provider/${id}/special_sale/${payload.id}`
      const data = {
        _method: 'patch',
        title: payload.offer.title,
        description: payload.offer.description,
        expires_at: payload.offer.expires_at
      }
      try {
        const response = await ApiUtils.makePost(url, data)
        if (response.ok) {
          ctx.commit('saveEditedOffer', payload)
          ctx.commit('showSnackBar', 'Cambios Guardados', {root: true})
          return {ok: true}
        }
        return {ok: false}
      } catch (error) {

        return {ok: false}
      }
    }
  },
  getters: {
    allOffers: state => state.offers
  }
}

function mapOffers(offers) {
  return offers.map(item => {
    const el = {
      id: item.id,
      expires: item.expires_at,
      created: item.created_at,
      active: !!item.active,
      serviceItemId: item.service_item.id,
      serviceItem: item.service_item.description,
      serviceId: item.service_item.service.id,
      service: item.service_item.service.name,
      type: item.service_item.type,
      discount: item.discount,
      title: item.title,
      description: item.description,
      image: item.image
    }
    return el
  })
}

function mapSingleOffer(item) {
  return {
    id: item.id,
    expires: item.expires_at,
    created: item.created_at,
    active: !!item.active,
    serviceItemId: item.service_item.id,
    serviceItem: item.service_item.description,
    serviceId: item.service_item.service.id,
    service: item.service_item.service.name,
    type: item.service_item.type,
    discount: item.discount,
    title: item.title,
    description: item.description,
    image: item.image
  }
}
